import { Component, signal, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AiService } from '@app/services/ai.service';
import { AnalyticsService } from '@shared/services/analytics.service';
import { AgentsService } from '@app/services/agents.service';

@Component({
  selector: 'blu-agent-instructions',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './instructions.component.html',
  styleUrl: './instructions.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InstructionsComponent {
  formattingText = false;
  formattedText = signal('');
  agent$ = this.agentsService.agent$;

  constructor(
    private aiService: AiService,
    public analyticsService: AnalyticsService,
    private agentsService: AgentsService,
  ) {}
  async formatText() {
    const agent = this.agentsService.getCurrentAgent();
    this.formattingText = true;
    if (!agent.configuration.prompt) return;
    const formattedText = await this.aiService.formatAgentInstruction(
      agent.configuration.prompt,
    );
    agent.configuration.prompt = formattedText;
    this.formattedText.set(formattedText);
    this.formattingText = false;
  }
}
